import React from 'react';

const groupResult = (result) => {
  const groups = {};

  result.forEach((item) => {
    if (groups[item.categoryId]) {
      groups[item.categoryId].items.push(item);
    } else {
      groups[item.categoryId] = { name: item.category, items: [item] };
    }
  });

  return groups;
};

const ResultGroupItem = ({ group, selectedItem, searchUrl }) => {
  if (!group) return null;

  const renderGroupHeader = () => {
    const firstItem = group.items[0];
    if (firstItem?.showAll === false && firstItem?.categoryId !== 'NoHit') {
      return (
        <h3 className="quick-search-result__group-header">
          {group.name}
        </h3>
      );
    }
  };

  const renderItem = (item, index) => {
    const itemClass = `quick-search-result__item ${selectedItem === index ? 'quick-search-result__item--selected' : ''
      }`;
    const linkClass = item.showAll
      ? 'quick-search-result__show-all'
      : `quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'
      }`;
    const linkHref = item.showAll ? searchUrl : item.url;

    return (
      <li key={`${item.name}-${index}`} className={itemClass}>
        <a className={linkClass} href={linkHref}>
          {item.hasImage && item.imageSource && (
            <img
              className="quick-search-result__image"
              src={item.imageSource}
            />
          )}
          <div>
          <p>{item.displayName ? `${item.displayName}` : item.name}</p>
            {item.showAll === false && (
              <p className="quick-search-result__article-number">
                {item.articleNumber}
              </p>
            )}
          </div>
        </a>
      </li>
    );
  };

  return (
    <div className="quick-search-result__group">
      {renderGroupHeader()}
      <ul>{group.items.map(renderItem)}</ul>
    </div>
  );
};

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
  const resultGroups = groupResult(result);

  const hasItemsInSecondColumn = ['MediaDocuments'].some(
    (group) => resultGroups[group]?.items.length > 0
  );

  return (
    <div className="quick-search-result">
      {resultGroups['NoHit'] ? (
        <div className="quick-search-result__column">
          <ResultGroupItem
            group={resultGroups['NoHit']}
            selectedItem={selectedItem}
            searchUrl={searchUrl}
          />
        </div>
      ) : (
        <div className="quick-search-result__grid">
          <div className="quick-search-result__column">
            <ResultGroupItem
              group={resultGroups['ExactMatch']}
              selectedItem={selectedItem}
              searchUrl={searchUrl}
            />
            <ResultGroupItem
              group={resultGroups['Products']}
              selectedItem={selectedItem}
              searchUrl={searchUrl}
            />
          </div>
          {hasItemsInSecondColumn && (
            <div className="quick-search-result__column">
              <ResultGroupItem
                group={resultGroups['MediaDocuments']}
                selectedItem={selectedItem}
                searchUrl={searchUrl}
              />
              {/*<ResultGroupItem*/}
              {/*  group={resultGroups['Categories']}*/}
              {/*  selectedItem={selectedItem}*/}
              {/*  searchUrl={searchUrl}*/}
              {/*/>*/}
              {/*<ResultGroupItem*/}
              {/*  group={resultGroups['Pages']}*/}
              {/*  selectedItem={selectedItem}*/}
              {/*  searchUrl={searchUrl}*/}
              {/*/>*/}
            </div>
          )}
        </div>
      )}
      {resultGroups['ShowAll'] && (
        <div className="quick-search-result__show-all button small secondary">
          <ResultGroupItem
            group={resultGroups['ShowAll']}
            selectedItem={selectedItem}
            searchUrl={searchUrl}
          />
        </div>
      )}
    </div>
  );
};

export default QuickSearchResult;